
import store from '@utils/store';
import api from './api';

export default {
  REGTYPE: {
    fb: 101,
    tw: 103,
    google: 102,
    ins: 105,
    line: 110,
    email: 108,
    phone: 104
  },
  toBase64: window.Base64.toBase64,
  fromBase64: window.Base64.fromBase64,
  validate(value, type) {
    const Valitor = {
      email: {
        pattern: '^[0-9a-zA-Z]+([-_.]*[A-Za-z0-9]+)*[_]*@([A-Za-z0-9]+[-.])+[A-Za-z0-9]{2,5}$'
      },
      password: {
        pattern: '^.{6,20}$'
      },
      phone: {
        pattern: '^[0-9]*$'
      },
      name: {
        pattern: '^[A-Za-z0-9\u4e00-\u9fa5]+$'
      }
    };
    if (new RegExp(Valitor[type].pattern).test(value)) {
      return true;
    }
    return false;
  },
  getQueryData(queryString) {
    queryString = queryString.replace(/^\?+/, '').replace(/&amp;/, '&');
    const querys = queryString.split('&');
    let i = querys.length;
    const urlParams = {};
    // eslint-disable-next-line no-plusplus
    while (i--) {
      const item = querys[i].split('=');
      if (item[0]) {
        let value = item[1] || '';
        try {
          value = decodeURIComponent(value);
        } catch (e) {
          value = unescape(value);
        }
        urlParams[decodeURIComponent(item[0])] = value;
      }
    }
    return urlParams;
  },
  loginAction(callback) {
    const queryData = this.getQueryData(window.location.search);
    if (queryData && queryData.code && !this.isLogined()) {
      api.code2Token(queryData.code).then((data) => {
        if (data.access_token) {
          // accessToken, regType, keep = 0, callback is_new=true 新用户
          const regType = store.get('regType');
          const keep = queryData.is_new === 'true' ? '1' : '0';
          this.userInfo(data.access_token, regType, keep, callback, '');
        }
      });
    } else {
      const uinfo = this.getUserInfo();
      if (uinfo && callback) {
        callback('success', uinfo);
      }
    }
  },
  logoutAction(callback) {
    store.remove('userInfo');
    store.remove('deviceid');
    callback && callback();
  },
  isLogined() {
    const uinfo = store.get('userInfo');
    return !!uinfo;
  },
  updateUserInfo(uinfo, callback) {
    store.set('userInfo', this.toBase64(JSON.stringify(uinfo)));
    if (uinfo.deviceid) { store.set('deviceid', uinfo.deviceid) }
    callback && callback(uinfo);
  },
  getUserInfo() {
    const value = store.get('userInfo');
    return value ? JSON.parse(this.fromBase64(value)) : '';
  },
  thirdLogin(name) {
    const regType = this.REGTYPE[name];
    store.set('regType', regType);
  },
  register(name, password, code, verifyCode, verifyCodeType, regType, keep, callback) {
    api.register(name, password, code, verifyCode, verifyCodeType).then((data) => {
      if (data.ret === '1') {
        this.userInfo(data.access_token, regType, keep, callback, name);
      } else {
        callback && callback('fail', data);
      }
    }).catch((response) => {
      // 这种情况 是 同盾 tongdun_black_box 没有 没有进行注册 需要用户再次尝试
      if (response === 'tongdun_fail') {
        callback && callback('tongdun_fail', response);
        return;
      }
      callback && callback('fail', response);
    });
  },
  channelSignin(name, password, code, mPublicKey, regType, keep, callback) {
    api.channelSignin(name, password, code, mPublicKey).then((data) => {
      // console.log('asdfasdfsadfsdf11', data);
      // need_captcha
      if (data && data.need_captcha === '1') {
        callback && callback('need_captcha', data);
      } else {
        this.userInfo(data.access_token, regType, keep, callback, name);
      }
    }).catch((response) => {
      // console.log('asdfasdfsadfsdf22', response);
      callback && callback('fail', response);
      this.report('fail', keep, '', regType, name, JSON.stringify(response.data ? response.data : {}));
    });
  },
  userInfo(accessToken, regType, keep = 0, callback, account) {
    api.userInfo(accessToken, regType, keep).then((data) => {
      if ((window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(`${data.status}`) >= 0) || (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(data.data && `${data.data.status}`) >= 0)) {
        callback && callback('fail', data);
        this.report('fail', keep, '', regType, account, JSON.stringify(data));
      } else {
        const userData = data;
        userData.deviceid = api.androidid;
        this.updateUserInfo(userData);
        store.set('regType', regType);
        callback && callback('success', userData);
        this.report('success', keep, userData.user.uid, regType, account, JSON.stringify(data));
      }
    }).catch((response) => {
      if (keep === 0 && response.data && response.data.status === '404') {
        // this.activeEmail(accessToken, regType, keep, callback, account);
        this.userInfo(accessToken, regType, 1, callback, account);
        return;
      }
      response.accessToken = accessToken;
      callback && callback('fail', response);
      this.report('fail', keep, '', regType, account, JSON.stringify(response.data ? response.data : {}));
    });
  },
  report(state, type, uid, way, account, msg) {
    // 增加官网注册埋点上报，包括UID、时间戳、国家、大区、注册方式及账号（手机、邮箱、Twitter、Facebook、Google、line）
    // keep=0 是登录 =1 是注册
    const params = {
      state: '', // success fail
      type: '', // =0 是登录 =1 是注册
      uid: '', // uid
      timestamp: '', // 时间戳
      way: '', // 方式 phone
      account: '', // 账号
      returnInfo: ''
    };
    if (window.KEWLSensor) {
      window.KEWLSensor.register('kewlweb_logregpoint', params);
      window.KEWLSensor.track({
        state,
        type,
        uid,
        way,
        account,
        timestamp: new Date().valueOf(),
        returnInfo: msg
      });
    }
  },
  selectLoginWay(way) {
    let regType = '';
    switch (way.name) {
      case 'fb':
        regType = '101';
        break;
      case 'tw':
        regType = '103';
        break;
      case 'google':
        regType = '102';
        break;
      case 'ins':
        regType = '105';
        break;
      case 'line':
        regType = '110';
        break;
      case 'email':
        regType = '108';
        break;
      case 'phone':
        regType = '104';
        break;
      default:
        break;
    }
    localStorage.removeItem('keep'); // 注册框点击第三方注册需要传 keep是否强制注册，0不是，1是
    localStorage.setItem('regType', regType); // 登录标识
  }
};
